import React, { useState } from "react";
import CustomModal from "../../components/generic/custommodal/CustomModal";
import ChangePin from "./ChangePin";
import SecondaryButton from "../../components/generic/buttons/SecondaryButton";
import PrimaryButton from "../../components/generic/buttons/PrimaryButton";
import { hashPassword } from "../auth/validator/utils";
import { useReadMemory } from "../generic/hooks/useReadMemory";
import MemoryType from "../../service/memory/enum/MemoryType";
import apiService from "../../service/apiservice/apiService";
import { notification } from "antd";
import { publishEvent } from "../../components/generic/EventPublisher";

const ChangePinModal = ({ isPinModalVisible, setPinModalVisible }) => {
  const userJson = useReadMemory(MemoryType.USER);
  const [oldPasskey, setOldPasskey] = useState("");
  const [newPasskey, setNewPasskey] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChangePin = async () => {
    if (newPasskey.length === 6) {
      setLoading(true);
      const oldHashPasskey = await hashPassword(oldPasskey);
      const newHashPasskey = await hashPassword(newPasskey);

      const payload = {
        oldPasskey: oldHashPasskey,
        newPasskey: newHashPasskey,
        userIdentifier: userJson?.userIdentifier,
      };
      const response = await apiService.post(
        "niramayafoundation/auth/api/v1/updatepin",
        payload
      );
      if (response.value) {
        notification.success({
          message: response.message,
          placement: "bottomRight",
        });
        setPinModalVisible(false);
        publishEvent("niramaya.volunteer.pin.update", userJson, userJson)
      } else {
        setErrorMsg(response.message);
      }
      setLoading(false);
    } else {
      setErrorMsg("PIN must be 6 digits long.");
    }
  };

  const footerButtons = (
    <>
      <SecondaryButton
        buttonText={"Cancel"}
        handleOnClick={() => setPinModalVisible(false)}
      />
      <PrimaryButton
        buttonText={"Update Pin"}
        handleOnClick={handleChangePin}
        loading={loading}
      />
    </>
  );
  return (
    <>
      <CustomModal
        closable={true}
        isModalOpen={isPinModalVisible}
        closeModal={setPinModalVisible}
        footer={[footerButtons]}
        title="Update PIN"
      >
        <ChangePin
          oldPasskey={oldPasskey}
          setOldPasskey={setOldPasskey}
          newPasskey={newPasskey}
          setNewPasskey={setNewPasskey}
          errorMsg={errorMsg}
        />
      </CustomModal>
    </>
  );
};

export default ChangePinModal;
